// Generated by Melange

import * as Caml_option from "melange.js/caml_option.js";
import * as Cn from "../../../../../vendored/classnames/Cn.js";
import * as Curry from "melange.js/curry.js";
import * as JsxRuntime from "react/jsx-runtime";

function container(disabled) {
  return Cn.fromList({
    hd: "flex",
    tl: {
      hd: disabled ? "cursor-not-allowed" : "cursor-pointer",
      tl: /* [] */ 0
    }
  });
}

function indicator(checked, hasError, disabled) {
  return Cn.fromList({
    hd: "w-4 h-4 mr-1 rounded-full relative border flex items-center justify-center shrink-0 translate-y-0.5",
    tl: {
      hd: Cn.on("bg-links border-links", checked),
      tl: {
        hd: Cn.on("border-default-gray bg-white", !checked),
        tl: {
          hd: Cn.on("bg-gray-pale border-gray-main", disabled),
          tl: {
            hd: Cn.on("bg-alert border-alert", hasError),
            tl: /* [] */ 0
          }
        }
      }
    }
  });
}

const Styles = {
  container: container,
  indicator: indicator
};

function RadioButton(Props) {
  let className = Props.className;
  let checkedOpt = Props.checked;
  let onChangeOpt = Props.onChange;
  let value = Props.value;
  let hasErrorOpt = Props.hasError;
  let disabledOpt = Props.disabled;
  let children = Props.children;
  const checked = checkedOpt !== undefined ? checkedOpt : false;
  const onChange = onChangeOpt !== undefined ? onChangeOpt : (function (param) {
      
    });
  const hasError = hasErrorOpt !== undefined ? hasErrorOpt : false;
  const disabled = disabledOpt !== undefined ? disabledOpt : false;
  let tmp = {
    hidden: true,
    checked: checked,
    type: "radio",
    onChange: (function (param) {
      Curry._1(onChange, undefined);
    })
  };
  if (value !== undefined) {
    tmp.value = Caml_option.valFromOption(value);
  }
  return JsxRuntime.jsxs("label", {
    children: [
      JsxRuntime.jsx("span", {
        children: JsxRuntime.jsx("span", {
          className: "w-1.5 h-1.5 bg-white rounded-full"
        }),
        className: indicator(checked, hasError, disabled)
      }),
      JsxRuntime.jsx("input", tmp),
      children
    ],
    className: Cn.fromList({
      hd: container(disabled),
      tl: {
        hd: Cn.take(className),
        tl: /* [] */ 0
      }
    })
  });
}

const make = RadioButton;

export {
  Styles,
  make,
}
/* react/jsx-runtime Not a pure module */
